import { render, staticRenderFns } from "./TaxReports.vue?vue&type=template&id=20774a8e"
import script from "./TaxReports.vue?vue&type=script&lang=js"
export * from "./TaxReports.vue?vue&type=script&lang=js"
import style0 from "./TaxReports.vue?vue&type=style&index=0&id=20774a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports